import { ArrowLeft, ArrowRight, LockKeyhole, ShieldCheck } from "lucide-react";
import { Mark } from "../../../components/public-site";

export function ProductionSignIn() {
  const office = new URLSearchParams(window.location.search).has("office");
  return (
    <div className="dc-login">
      <div className="dc-login-main">
        <Mark />
        <div>
          <p className="dc-eyebrow">{office ? "PLATFORM ADMINISTRATION" : "YOUR PERSONAL CHAMBER"}</p>
          <h1>{office ? "An orderly platform." : "Welcome to"}<br /><em>{office ? "A considered office." : "your chamber."}</em></h1>
          <p>{office ? "A separate place to manage chambers and operational health." : "Your matters, your documents, your next clear step. Right where you left them."}</p>
          <div className="dc-login-box">
            <div className="dc-login-icon">
              {office ? <ShieldCheck /> : <LockKeyhole />}
              <span>{office ? "Administration access" : "Advocate access"}<small>Password, recovery and authenticator MFA</small></span>
            </div>
            <p className="dc-note">Private AWS staging. Only invited test identities can continue.</p>
            <a className="dc-action" href={`/api/auth/start?office=${office ? "1" : "0"}`}>Continue securely <ArrowRight size={16} /></a>
          </div>
          <a className="dc-text-link" href={office ? "/sign-in" : "/sign-in?office=1"}>{office ? "Return to advocate sign in" : "Platform administrator?"}<ArrowRight size={14} /></a>
        </div>
        <a className="dc-text-link" href="/"><ArrowLeft size={14} />Back to Digital Chambers</a>
      </div>
      <div className="dc-login-art">
        <img src="/chamber-hero.png" alt="A calm advocate’s desk" />
        <div><small>THE FOUNDING EDITION</small><h2>Space for your<br /><em>finest work.</em></h2><p>Digital Chambers · A MindForgeAI product</p></div>
      </div>
    </div>
  );
}
